<!-- eslint-disable max-len -->
<h1 class="text-title mt-3" i18n>You're almost done!</h1>

<div class="mt-4 mb-5" *ngIf="isUsaEnv">
  <div class="mb-2">
    <span class="font-weight-bold mr-2" i18n>Social Security Number - </span>
    <span class="font-italic" i18n>Don't worry this is a secure site!</span>
  </div>
  <div class="row">
    <div class="col-8 col-md-3" [formGroup]="ssnNumberFormGroup">
      <app-ssn-number-field-input
        [control]="ssnNumberFormGroup.controls[SsnNumberFieldName]"
      ></app-ssn-number-field-input>
    </div>
    <div class="col-auto">
      <i class="bi bi-lock-fill lock-size"></i>
    </div>
  </div>
  <div *ngIf="(agreementStep$ | async).ssnNumberIsValid === false" class="validation-error-message">
    <span>{{ SsnErrorMessage }}</span>
  </div>
</div>



<div *ngIf="!documentCompleted">
  <h6 class="text-subtitle pr-3 pr-md-0" i18n>
    Please review and agree to the Consultant Agreement below
  </h6>

  <iframe
    *ngIf="pandaDocUrl"
    [src]="pandaDocUrl | safeUrl"
    scrolling="yes"
    class="agreement"
    id="pandaDocFrame"
    title="PandaDoc Document"
    allow="camera; microphone"
  ></iframe>
</div>
<div  class="mb-2" *ngIf="!documentCompleted">
  <span class="font-italic" i18n>
  After your agreement is signed, a copy will be sent to you via email. 
    You can also view and print your signed agreement at any time from Personal Documents 
    in Consultant's Corner.
  </span>
</div>
<div
*ngIf="pandaDocError && !documentCompleted"
class="validation-error-message mb-3"
role="alert"
>
  <span i18n>We're unable to submit your digital signature at this time. Please try again later.
    If the issue persists, contact Customer Support for assistance.
  </span>
</div>
<div
  *ngIf="documentNotSignedError && !documentCompleted"
  class="validation-error-message mb-3"
  role="alert"
>
  <span i18n>Please sign the Consultant Agreement before continuing.</span>
</div>
<div *ngIf="documentCompleted" class="AgreementSuccess-container">
  <img src="https://stecmexprod002.blob.core.windows.net/sitefinity/images/default-source/corporate-site/sna-icons/success-icon.png?sfvrsn=709193ec_1" 
        class="AgreementSuccess-icon"/>

        <h3 class="AgreementSuccess-title">
          <span i18n>Signature Submitted</span>
        </h3>
      
        <p class="AgreementSuccess-text">
          <span i18n>Our agreement terms have been successfully signed.</span>
          
        </p>
</div>

<div *ngIf="agreementStep$ | async as agreement">
  <div
    *ngIf="
      ((!!agreement.statusCode && agreement.statusCode !== StatusCodes.OK) ||
        !!agreement.errors.length) &&
      agreement.ssnNumberIsValid !== false
    "
    class="validation-error-message mb-3"
  >
    <app-sna-http-status-errors [statusCode]="agreement.statusCode"></app-sna-http-status-errors>
  </div>
</div>
